/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from 'react-bootstrap';
import { KTIcon } from '../../../_metronic_front/helpers'; 
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToastMessageSuccess, showToastMessageError } from '../../modules/Toast-Message/TosatMessage'; 
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import StatementItem from '../statements/StatementItem';

const modalsRoot = document.getElementById('root-modals') || document.body;

 const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
    const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    return JSON.parse(data)
}

const WithdrawDetail = ({ show, handleClose, withdrawId }) => {
    
    const [errorMsg, setErrorMsg] = useState("");
    const [fetchCount,setFetchCount] = useState(true);
    const [withdrawStatements,setWithdrawStatements] = useState([]);
    const [loading,setLoading] = useState(true);

    const [openDropdown, setOpenDropdown] = useState(null);
    const [statementItems, setStatementItems] = useState({})

    const apiToken = getLocalData().api_token
    const API_URL = process.env.REACT_APP_API_URL;
    const WITHDRAW_DETAIL_URL = `${API_URL}/user/withdraw-detail`;
    const STATEMENT_DETAIL = `${API_URL}/user/Statement/detail`
    const isMobileDevice = MobileUse();

    const getWithdrawDetail = async () => {
            await axios.post(WITHDRAW_DETAIL_URL, {
                withdraw_id: withdrawId,
            }).then((response) => {
                    setWithdrawStatements(response.data.data);
                    console.log(response.data.data);
                    setLoading(false);
                    
            }).catch((error) => {
                console.error(error);
            });
    };

    const setModalClose = ()=>{
        handleClose();
        setWithdrawStatements([]);
        setOpenDropdown();
        setStatementItems({});
        setLoading(true);
    }

    const getStatementDetail = async (stmtId) => {
        // setLoading(true)
        const config = {
        headers: {Authorization: `Bearer ${apiToken}`},
        params : {
            'statement_id':stmtId
        }
        }
        await axios
        .get(STATEMENT_DETAIL, config)
        .then((response) => {
            setStatementItems((prev)=>({
                ...prev,
                [stmtId]:response.data.items,
            }));
            // console.log(response.data)
            // setLoading(false)
        })
        .catch((error) => {
            console.error(error)
            // setLoading(false)
        })
    }

    const handleItemsClick = (stmtId)=>{
        if(!statementItems[stmtId]){
            getStatementDetail(stmtId)
        }
        setOpenDropdown((prev) => (prev === stmtId) ? null : stmtId)
    }

    //  const OpenViewStatementModal = (stmtId) => {
    //     // setStatementId(stmtId)
    //     getStatementDetail(stmtId)
    //     setShowStatementDetailModal(true)
    // }

    const getDueDate = (date) =>{
        const mydate = new Date(date);
        const dueDate = addDays(mydate, 15);
        return formatDate(dueDate);
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString); // Convert the ISO string to a Date object
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getFullYear();
        return `${month}-${day}-${year}`;
      };

    const addDays = (date, days) => {
        const result = new Date(date); 
        result.setDate(result.getDate() + days);
        return result;
      };
 
    useEffect(() => {
        if (show && withdrawId) {
            getWithdrawDetail();
        }
        setErrorMsg("");
    }, [show, withdrawId]);

    const TrackingItems = ({stmtId})=>{
        return(
            <div className='dropdown position-relative'>
                <button className='btn btn-sm btn-light dropdown-toggle' onClick={() => handleItemsClick(stmtId)}>Items</button>
                {openDropdown == stmtId && (
                    <>
                    <div className="dropdown-menu show" style={!isMobileDevice ? { display: "block",width:750,maxHeight:300,overflow:'auto'} 
                    : {display: "block",marginLeft:'-100px',width:'99vw',overflow:'auto'}}>
                    <div className="accordion">
                        {(statementItems[stmtId] || [])?.map((item, index) => (
                            <div key={item.id || index} className="dropdown-item">
                                <StatementItem item={item} index={index} />
                            </div>
                    ))}
                    </div>
                    </div>
                    </>
                )}
            </div>
        )
    }

    return createPortal(
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName='modal-dialog modal-dialog-centered modal-xl'
            show={show}
            onHide={setModalClose}
            backdrop={true}
        >
            <ToastContainer />
            <div className='modal-header pb-0'>
                <h2>Statements on Withdraw</h2>
                <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={setModalClose}>
                    <KTIcon className='fs-1' iconName='cross' />
                </div>
            </div>

            <div className='card'>
                <div className='card-body d-flex pt-0 px-0 px-lg-2'>
                    {!loading ? (
                        <>
                        {!isMobileDevice ? (
                        <div className="table-responsive" style={{overflow:'visible'}}>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Stmt</th>
                                        <th>Tracking</th>
                                        <th>Items</th>
                                        <th>Amount</th>
                                        <th>Due Date</th>
                                        <th>Scanned On</th>
                                        <th>Paid On</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {withdrawStatements.map((val,index)=>(
                                    <tr>
                                        <td>{val.statement_no}</td>
                                        <td>{val.tracking_no}</td>
                                        <td><TrackingItems stmtId={val.stmtid}/></td>
                                        <td>${val.stmt_price.toFixed(2)}</td>
                                        <td>{getDueDate(val.created_at)}</td>
                                        <td>{formatDate(val.created_at)}</td>
                                        <td>{formatDate(val.payment_date)}</td>
                                        {(val.payment_status == 2 || val.payment_status == 3) ? (
                                            <td><span className='badge badge-success'>PARTIAL PAID</span></td>
                                        ) : (
                                        <td><span className='badge badge-success'>PAID</span></td>
                                        )    
                                    }
                                    </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>
                        ) : (
                            <div className="table-responsive" style={{overflow:'visible'}}>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Stmt</th>
                                        <th>Description</th>
                                        <th>Amount</th>
                                        {/* <th>Due Date</th>
                                        <th>Scanned On</th>
                                        <th>Paid On</th>
                                        <th>Status</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {withdrawStatements.map((val,index)=>(
                                    <tr>
                                        <td>{val.statement_no}</td>
                                        <td>
                                            <h6>{val.tracking_no}</h6>
                                            <span>Scanned On : {formatDate(val.created_at)}</span><br/>
                                            <span>Due Date : {getDueDate(val.created_at)}</span><br/>
                                            <TrackingItems stmtId={val.stmtid}/>
                                            </td>
                                        <td>
                                            <span>${val.stmt_price.toFixed(2)}</span>
                                            {(val.payment_status == 2 || val.payment_status == 3) ? (
                                                <span className='badge badge-success'>PARTIAL PAID</span>
                                            ) : (
                                            <span className='badge badge-success'>PAID</span>
                                            )}
                                        </td>
                                        {/* <td>{getDueDate(val.created_at)}</td>
                                        <td>{formatDate(val.created_at)}</td>
                                        <td>{formatDate(val.payment_date)}</td> */}
                                        
                                    </tr>
                                    ))
                                }
                                
                                </tbody>
                            </table>
                        </div>
                        )}
                        </>
                    ) : (
                        <div className='text-center'>
                            <span>Loading....</span>
                        </div>
                    )}
                        
                    
                </div>
            </div>
        </Modal>,
        modalsRoot
    );
}

export { WithdrawDetail };
